import React from "react";

import { DEFAULT_CORRELATION_ID } from "./constants";
import { CorrelationIdContextValue } from "./types";

export const CorrelationIdContext = React.createContext<CorrelationIdContextValue>({
  correlationId: DEFAULT_CORRELATION_ID,
});
